import { theme, type Types } from '@fiverr-private/theme';

export const getStrokeColor = (color: Types.Color) => {
    if (color === 'inherit') {
        return 'currentColor';
    }
    return theme.colors[color];
};
